import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import images from src/images/
import siteInitiation1 from '../images/Mombasa.jpg';
import siteInitiation2 from '../images/Kilifi.jpg';
import siteInitiation3 from '../images/Bamba.jpg';
import CountyGovernment from '../images/Engagement_County.jpg';
import Mosquitotrap1 from '../images/Trap1.jpg';
import Mosquitotrap2 from '../images/Trap2.jpg';
import mosquitoTraps3 from '../images/Trap3.jpg';
import mosquitoTraps4 from '../images/Trap4.jpg';
import mosquitotrap5 from '../images/Trap5.jpg';
import mosquitotrap6 from '../images/Trap6.jpg';

const activities = [
  {
    title: 'Dengue Outbreak Response in Coastal Kenya',
    date: '2025-06',
    description: 'Collaborated with KEMRI on real-time tracking using SORMAS, reducing response time by 40%.',
  },
  {
    title: 'Mosquito Trap Monitoring Workshop',
    date: '2025-08',
    description: 'Trained entomologists on VectorScope app in Mombasa and Kilifi Counties.',
  },
  {
    title: 'KASH conference Presentation',
    date: '2025-07',
    description: 'Presented on digital public health tools at KASH conference.',
  },
  {
    title: 'Community Health Outreach',
    date: '2025-09',
    description: 'Engaged rural communities in Kilifi, Transzoia and Mombasa on vector control education.',
  },
];

const imageGallery = [
  {
    id: 1,
    image: siteInitiation1,
    caption: 'Site Initiation Visit for Dengue Surveillance in Coastal Region',
    alt: 'Team conducting dengue surveillance site initiation in Mombasa',
  },
  {
    id: 2,
    image: siteInitiation2,
    caption: 'Training Health Workers During Site Initiation',
    alt: 'Health workers training session for dengue surveillance in Kilifi',
  },
  {
    id: 3,
    image: siteInitiation3,
    caption: 'Engaging Local Health Officials in Bamba',
    alt: 'Site initiation meeting with local health officials in Bamba',
  },
  {
    id: 4,
    image: CountyGovernment,
    caption: 'Engagement with County Government Officials',
    alt: 'Meeting with county government officials for dengue surveillance collaboration',
  },
  {
    id: 5,
    image: Mosquitotrap1,
    caption: 'Deploying Mosquito Traps in Coastal Kenya',
    alt: 'Entomologist deploying mosquito traps for vector surveillance in coastal Kenya',
  },
  {
    id: 6,
    image: Mosquitotrap2,
    caption: 'Setting Mosquito Traps for Vector Surveillance in Mombasa',
    alt: 'Entomologist setting mosquito traps for vector surveillance in Mombasa',
  },
  {
    id: 7,
    image: mosquitoTraps3,
    caption: 'BG Sentinel Setup for Mosquito Trapping in Mombasa',
    alt: 'Vector surveillance mosquito trap monitoring in Mombasa',
  },
  {
    id: 8,
    image: mosquitoTraps4,
    caption: 'A UV Light Mosquito Trap in Kilifi',
    alt: 'UV light mosquito trap setup for vector surveillance in Kilifi',
  },
  {
    id: 9,
    image: mosquitotrap5,
    caption: 'Entomologist Demonstrating How to Set Up a Mosquito Trap',
    alt: 'Entomologist demonstrating mosquito trap setup for vector surveillance in Kilifi',
  },
  {
    id: 10,
    image: mosquitotrap6,
    caption: 'A Trained Health Worker in Mombasa Setting Up a Mosquito Trap',
    alt: 'Trained health worker setting up mosquito trap for vector surveillance in Mombasa',
  },
];

const Activities = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <section id="activities" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-8 text-blue-800 font-poppins">Our Activities & Works Undertaken</h2>
        <p className="text-gray-600 mb-12 text-center max-w-2xl mx-auto font-poppins">
          Discover our efforts in dengue surveillance, community engagement, and vector control across Kenya’s coastal region.
        </p>

        {/* Image Carousel */}
        <div className="max-w-4xl mx-auto mb-16 bg-white rounded-xl shadow-lg overflow-hidden">
          <Slider
            {...sliderSettings}
            className="relative"
            customPaging={() => (
              <button className="w-3 h-3 bg-teal-500 rounded-full hover:bg-teal-600 transition-all" />
            )}
            dotsClass="slick-dots mt-4 flex justify-center space-x-2"
            prevArrow={
              <button className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 transition-all z-10">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            }
            nextArrow={
              <button className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 transition-all z-10">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            }
          >
            {imageGallery.map((item) => (
              <div key={item.id} className="px-4 py-4">
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-contain rounded-lg shadow-md"
                    loading="lazy"
                  />
                </div>
                <p className="text-center text-gray-700 mt-4 font-medium font-poppins">{item.caption}</p>
              </div>
            ))}
          </Slider>
        </div>

        {/* Text-Based Activity Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((activity, index) => (
            <div
              key={index}
              className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <h3 className="text-xl font-semibold mb-2 text-teal-600 font-poppins">{activity.title}</h3>
              <p className="text-gray-500 mb-4 font-poppins">{activity.date}</p>
              <p className="text-gray-600 font-poppins">{activity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Activities;